<template>
  <div style="height: 100%">
    <portal to="app-header">
      <span>Billing Management</span>
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            small
            v-bind="attrs"
            v-on="on"
            class="ml-2 mb-1"
            @click="setDrawer(!drawer)"
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>
        Navigation
      </v-tooltip>
    </portal>
    <v-navigation-drawer
      v-model="model"
      fixed
      right
      clipped
      width="290"
      style="top: 64px; height: calc(100% - 64px);"
    >
      <div class="pt-4 px-2">
        <v-list nav dense>
          <v-list-item
            v-for="item in navigationItems"
            :key="item.title"
            :to="item.to"
            router
            exact
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      />
    </v-overlay>
    <v-fade-transition mode="out-in">
      <div
        class="billing-app-content"
        v-keyboard-navigation
        :style="model ? 'margin-right: 290px;' : ''"
      >
        <router-view />
      </div>
    </v-fade-transition>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import keyboardNavigation from '../directives/keyboardNavigation';

export default {
  name: 'BillingAppIndex',
  directives: {
    keyboardNavigation,
  },
  data() {
    return {
      loading: false,
      navigationItems: [
        {
          title: 'Dashboard',
          icon: 'mdi-view-dashboard',
          to: '/billing-app',
        },
        {
          title: 'Master Data',
          icon: 'mdi-database',
          to: '/billing-app/master-data',
        },
        {
          title: 'Electricity Billing Entry',
          icon: 'mdi-calculator',
          to: '/billing-app/billing-entry',
        },
        {
          title: 'Electricity Billing History',
          icon: 'mdi-history',
          to: '/billing-app/billing-history',
        },
        {
          title: 'DG Billing Entry',
          icon: 'mdi-engine',
          to: '/billing-app/dg-billing-entry',
        },
        {
          title: 'DG Billing History',
          icon: 'mdi-engine-outline',
          to: '/billing-app/dg-billing-history',
        },
      ],
    };
  },
  computed: {
    ...mapState('billingApp', ['drawer']),
    model: {
      get() {
        return this.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
  },
  async created() {
    this.loading = true;
    await this.getOnboardingState();
    this.loading = false;
  },
  methods: {
    ...mapActions('billingApp', ['getOnboardingState']),
    ...mapMutations('billingApp', ['setDrawer']),
  },
};
</script>

<style scoped>
.billing-app-content {
  padding: 16px 20px 24px;
  min-height: 100%;
  transition: margin-right 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

@media (max-width: 600px) {
  .billing-app-content {
    padding: 12px;
    margin-right: 0 !important;
  }
}
</style>
